export const MOL_V1ResourcesEN: MOL_V1ResourcesBSInterface = {
  labelDone: "Task completion date",
  errors: {
    registerPic: "The picture you are uploading is too large.",
    recordAlreadyExists:
      "This evidence has already been filled out. You cannot fill it out again.",
  },
  errorMissingInput: "Please fill in all fields",
  input: {
    signatureTitle: "Signature",
    datum: {
      label: "Date",
      placeholder: "Please enter date",
      name: "datum",
    },
    opis: {
      label: "Description",
      placeholder: "Please enter description",
      name: "opis",
    },
    izvrsioc: {
      label: "Work performer",
      placeholder: "Please enter work performer",
      name: "izvrsioc",
    },
    potpisIzvrsioca: {
      label: "Work performer signature",
    },
  },
  evidencijaForm: {
    buttonForward: "Sign",
    buttonBack: "Back",
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
};

interface InputField {
  label: string;
  placeholder?: string;
  name?: string;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  opis: InputField;
  izvrsioc: InputField;
  potpisIzvrsioca: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface MOL_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: IErrors;
}
